import { render, staticRenderFns } from "./PostVenta.vue?vue&type=template&id=1383e2ac&scoped=true"
import script from "./PostVenta.vue?vue&type=script&lang=ts"
export * from "./PostVenta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1383e2ac",
  null
  
)

export default component.exports